export default __webpack_public_path__ + "static/media/pro_aim_drawboard.2f862bf1.png";